<style>
@media (orientation: landscape) {
	#Landing--Header {
		padding-top: 11rem;
		padding-bottom: 11rem;
	}
}
</style>

<template>
	<div id="Hero--Cover"
		class="h-screen w-full bg-cover bg-top absolute bg-no-repeat opacity-10"
		style="background-image: url(/img/photo.webp);"></div>

	<section id="Landing--Header"
		class="bg-gold flex flex-col h-screen items-center pb-40 justify-center">
		<div class="relative flex flex-col justify-center text-center px-10">
			<h1 class="font-bold uppercase text-white text-5xl">{{ name }}</h1>
			<h2 class="font-semibold text-white uppercase text-xs my-0">{{ occupation }}</h2>
			<h3 class="font-semibold text-white text-xs my-0 mt-2 py-8 lg:pt-8 lg:pb-4 leading-6"
				v-html="$t('hero-header.description')"></h3>
		</div>
	</section>
</template>

<script>
import { HeroTimeline } from '@/animations/Hero.timeline'

export default {
	name: 'HeroHeader',

	data() {
		return {
			name: 'Carlos Pereira',
			occupation: 'Software Engineer',
		}
	},

	mounted() {
		HeroTimeline.start()
	},
}
</script>